import JoinContainer from "./containers/JoinContainer";
import CompanyJoinContainer from "./containers/CompanyJoinContainer";
import SpecialCheckContainer from "./containers/SpecialCheckContainer";
import EventCheckContainer from "./containers/EventCheckContainer";
import EventLoginContainer from "./containers/EventLoginContainer";
import Page404 from "./pages/page404";

import PageSuccess from "./pages/pageSuccess";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Route, Switch } from "react-router-dom";
import React from "react";
function App() {
  return (
    <CssBaseline>
      <Switch>
        <Route
          exact
          path="/crm/specialcheck"
          component={SpecialCheckContainer}
        />
        <Route exact path="/event" component={EventLoginContainer} />
        <Route exact path="/event/:partcode" component={EventCheckContainer} />
        <Route exact path="/crm/join/:partcode" component={JoinContainer} />
        <Route
          exact
          path="/crm/join/:partcode/company"
          component={CompanyJoinContainer}
        />
        <Route path="/success" component={PageSuccess} />
        <Route component={Page404} />
      </Switch>
    </CssBaseline>
  );
}

export default App;
